import logo from "./assets/SmallC.png";
import profile from "./assets/TestC(2).gif";

//import ProjectFig_1_1 from "./ProjectFolder/Project_1/alley_1.png";
import ProjectFig_1_2 from "./ProjectFolder/Project_1/alley_3.png";
import ProjectFig_1_3 from "./ProjectFolder/Project_1/C.png";
import ProjectFig_1_4 from "./ProjectFolder/Project_1/C_art.png";

import ProjectFig_2_1 from "./ProjectFolder/Project_2_re/Combine.png";
import ProjectFig_2_2 from "./ProjectFolder/Project_2_re/ParameterAdjustment.png";
import ProjectFig_2_3 from "./ProjectFolder/Project_2_re/ParameterAdjustment_2.png";
import ProjectFig_2_4 from "./ProjectFolder/Project_2_re/TicoBase.png";
import ProjectFig_2_5 from "./ProjectFolder/Project_2_re/Ticojoint.png";

import ProjectFig_3_1 from "./ProjectFolder/Project_3/Rendering.png";
import ProjectFig_3_2 from "./ProjectFolder/Project_3/TI locking component concept.jpg";
import ProjectFig_3_3 from "./ProjectFolder/Project_3/animation2.gif";
import ProjectFig_3_4 from "./ProjectFolder/Project_3/border element 02.jpg";
import ProjectFig_3_5 from "./ProjectFolder/Project_3/K truchet tililng.jpg";
import ProjectFig_3_6 from "./ProjectFolder/Project_3/post tension border element06.jpg";
import ProjectFig_3_7 from "./ProjectFolder/Project_3/S__2482202_0.jpg";
import ProjectFig_3_8 from "./ProjectFolder/Project_3/S__2482204_0.jpg";
import ProjectFig_3_9 from "./ProjectFolder/Project_3/S__2482205_0.jpg";
import ProjectFig_3_10 from "./ProjectFolder/Project_3/S__2482208_0.jpg";
import ProjectFig_3_11 from "./ProjectFolder/Project_3/S__2482209_0.jpg";
import ProjectFig_3_12 from "./ProjectFolder/Project_3/S__2482210_0.jpg";
import ProjectFig_3_13 from "./ProjectFolder/Project_3/S__2482211_0.jpg";
import ProjectFig_3_14 from "./ProjectFolder/Project_3/S__2482212_0.jpg";

import ProjectFig_4_1 from "./ProjectFolder/Project_4/E3B19C4F-5FC0-484D-A3FA-8B78217DE2D7.jpg";
import ProjectFig_4_2 from "./ProjectFolder/Project_4/282795B5-1692-4E07-AB62-F2BDCD9FCBED.jpg";
import ProjectFig_4_3 from "./ProjectFolder/Project_4/2594408D-29B6-4D50-BD43-FA994D2A547D.jpg";
import ProjectFig_4_4 from "./ProjectFolder/Project_4/BDBB3D17-BD7F-4B3B-BB8D-54C37245AD51.jpg";
import ProjectFig_4_5 from "./ProjectFolder/Project_4/788863B7-064B-4727-9913-B968539F5C2A.jpg";
import ProjectFig_4_6 from "./ProjectFolder/Project_4/7983CA98-8F2D-4B5B-BB96-EEF9C37A87B1.jpg";
import ProjectFig_4_7 from "./ProjectFolder/Project_4/27A05CB9-3097-45E1-8D84-6E9FECF06C26.jpg";
import ProjectFig_4_8 from "./ProjectFolder/Project_4/F9A3FD17-E50C-4B3B-9626-BA9F45434A9A.jpg";
import ProjectFig_4_9 from "./ProjectFolder/Project_4/A8C0F30F-D0D9-4B38-8B53-5A86703C3FEB.jpg";
import ProjectFig_4_10 from "./ProjectFolder/Project_4/026F9485-75CD-4278-86F7-D9514B3BF251.jpg";

import ProjectFig_5_1 from "./ProjectFolder/Project_5/1-FU HD_2.jpg";
import ProjectFig_5_2 from "./ProjectFolder/Project_5/5-FULL HD_2.jpg";
import ProjectFig_5_3 from "./ProjectFolder/Project_5/Analysis.png";
import ProjectFig_5_5 from "./ProjectFolder/Project_5/Drawing.png";
import ProjectFig_5_6 from "./ProjectFolder/Project_5/Final_com.jpg";
import ProjectFig_5_8 from "./ProjectFolder/Project_5/Process_1.png";

import ProjectFig_6_1 from "./ProjectFolder/Project_6/WORD blocks_2.jpg";
import ProjectFig_6_2 from "./ProjectFolder/Project_6/e.jpg";
import ProjectFig_6_3 from "./ProjectFolder/Project_6/WORD blocks_3.jpg";
import ProjectFig_6_4 from "./ProjectFolder/Project_6/WORD blocks_C.jpg";
import ProjectFig_6_5 from "./ProjectFolder/Project_6/WORD blocks_E.jpg";
import ProjectFig_6_6 from "./ProjectFolder/Project_6/WORD blocks_S.jpg";

import ProjectFig_7_1 from "./ProjectFolder/Project_7/-entrance IN_low3.0.jpg";
import ProjectFig_7_2 from "./ProjectFolder/Project_7/-innerFront3.0_3.jpg";
import ProjectFig_7_3 from "./ProjectFolder/Project_7/alley3.0.jpg";
import ProjectFig_7_4 from "./ProjectFolder/Project_7/Board_1_3.0.jpg";
import ProjectFig_7_5 from "./ProjectFolder/Project_7/entrance3.02.jpg";
import ProjectFig_7_6 from "./ProjectFolder/Project_7/TDL2.jpg";
import ProjectFig_7_7 from "./ProjectFolder/Project_7/TV3.02.jpg";

import ProjectFig_8_1 from "./ProjectFolder/Project_8/KPF.jpg";
import ProjectFig_8_2 from "./ProjectFolder/Project_8/parameters.png";
import ProjectFig_8_3 from "./ProjectFolder/Project_8/Compared_1.png";
import ProjectFig_8_4 from "./ProjectFolder/Project_8/Mold Analysis.png";
import ProjectFig_8_5 from "./ProjectFolder/Project_8/Mold Analysis_2.png";
import ProjectFig_8_6 from "./ProjectFolder/Project_8/Optimised.png";

import ProjectFig_9_1 from "./ProjectFolder/Project_9/33b58224326f85d515042e0b36085aa6a4092ff.jpg";
import ProjectFig_9_2 from "./ProjectFolder/Project_9/S__34103358.jpg";
import ProjectFig_9_3 from "./ProjectFolder/Project_9/S__34103359.jpg";
import ProjectFig_9_4 from "./ProjectFolder/Project_9/S__34103360.jpg";
import ProjectFig_9_5 from "./ProjectFolder/Project_9/Zodaic.png";
import ProjectFig_9_6 from "./ProjectFolder/Project_9/messageImage_1730712893841.jpg";
import ProjectFig_9_7 from "./ProjectFolder/Project_9/D687D645-0DBF-477D-9B78-0CD16B586738.jpg";
import ProjectFig_9_8 from "./ProjectFolder/Project_9/4D763ED6-615C-4674-A9E3-0399E6E139BC.jpg";

import ProjectFig_10_1 from "./ProjectFolder/Project_10/PolyVox.png";
import ProjectFig_10_2 from "./ProjectFolder/Project_10/1.jpg";
import ProjectFig_10_3 from "./ProjectFolder/Project_10/2.jpg";
import ProjectFig_10_4 from "./ProjectFolder/Project_10/fig 2a.jpg";
import ProjectFig_10_5 from "./ProjectFolder/Project_10/fig 4.jpg";
import ProjectFig_10_6 from "./ProjectFolder/Project_10/0502D3D5-3961-4C77-8C78-C1AB754C4636.jpg";
import ProjectFig_10_7 from "./ProjectFolder/Project_10/033234E1-1F85-48FC-967B-1F2F187A479B.jpg";

import ProjectFig_11_1 from "./ProjectFolder/Project_11/LINE_ALBUM_0518 W2紀錄_241104_1.jpg";
import ProjectFig_11_2 from "./ProjectFolder/Project_11/LINE_ALBUM_2024.3.28_241104_1.jpg";
import ProjectFig_11_3 from "./ProjectFolder/Project_11/LINE_ALBUM_2024.3.28_241104_2.jpg";
import ProjectFig_11_4 from "./ProjectFolder/Project_11/LINE_ALBUM_2024.3.28_241104_3.jpg";
import ProjectFig_11_5 from "./ProjectFolder/Project_11/Setting.png";

import ProjectFig_12_1 from "./ProjectFolder/Project_12/ViewCapture20241104_223014.png";
import ProjectFig_12_2 from "./ProjectFolder/Project_12/P2.png";

import ProjectFig_13_1 from "./ProjectFolder/Project_13/H1.png";
import ProjectFig_13_2 from "./ProjectFolder/Project_13/H2.png";
import ProjectFig_13_3 from "./ProjectFolder/Project_13/Map.png";
import ProjectFig_13_4 from "./ProjectFolder/Project_13/Dimension.png";
import ProjectFig_13_5 from "./ProjectFolder/Project_13/Hat2.png";
import ProjectFig_13_6 from "./ProjectFolder/Project_13/HatFrist.png";

import ProjectFig_14_1 from "./ProjectFolder/Project_14/Running.gif";
import ProjectFig_14_2 from "./ProjectFolder/Project_14/Dist_1.png";
import ProjectFig_14_3 from "./ProjectFolder/Project_14/Dist_2.png";
import ProjectFig_14_4 from "./ProjectFolder/Project_14/Dist_3.png";
import ProjectFig_14_5 from "./ProjectFolder/Project_14/Dist_4.png";

import ProjectFig_15_1 from "./ProjectFolder/Project_15/Component.png";
import ProjectFig_15_2 from "./ProjectFolder/Project_15/Models.png";
import ProjectFig_15_3 from "./ProjectFolder/Project_15/ParseTree.png";
import ProjectFig_15_4 from "./ProjectFolder/Project_15/ParserDiagram.png";
import ProjectFig_15_5 from "./ProjectFolder/Project_15/Path.png";
import ProjectFig_15_6 from "./ProjectFolder/Project_15/Result.png";
import ProjectFig_15_7 from "./ProjectFolder/Project_15/Transformation.png";
import ProjectFig_15_8 from "./ProjectFolder/Project_15/UnitDesign.png";
import ProjectFig_15_9 from "./ProjectFolder/Project_15/Result_2.png";

import ProjectFig_16_1 from "./ProjectFolder/Project_16/S__59965455_0.jpg";
import ProjectFig_16_2 from "./ProjectFolder/Project_16/S__59965456_0.jpg";
import ProjectFig_16_3 from "./ProjectFolder/Project_16/S__59965463_0.jpg";
import ProjectFig_16_4 from "./ProjectFolder/Project_16/S__59965464_0.jpg";
import ProjectFig_16_5 from "./ProjectFolder/Project_16/S__59965466_0.jpg";
import ProjectFig_16_6 from "./ProjectFolder/Project_16/Basilica.jpg";
import ProjectFig_16_7 from "./ProjectFolder/Project_16/Compared.png";
import ProjectFig_16_8 from "./ProjectFolder/Project_16/DeBasilica.png";
import ProjectFig_16_9 from "./ProjectFolder/Project_16/Top.png";
import ProjectFig_16_10 from "./ProjectFolder/Project_16/Mid.png";
import ProjectFig_16_11 from "./ProjectFolder/Project_16/Bot.png";
import ProjectFig_16_12 from "./ProjectFolder/Project_16/Door.png";
import ProjectFig_16_13 from "./ProjectFolder/Project_16/System.png";
import ProjectFig_16_14 from "./ProjectFolder/Project_16/Hierarchy.png";

import ProjectFig_17_1 from "./ProjectFolder/Project_17/AssembleTest.png";
import ProjectFig_17_2 from "./ProjectFolder/Project_17/Diagram.png";
import ProjectFig_17_3 from "./ProjectFolder/Project_17/Issues.png";
import ProjectFig_17_4 from "./ProjectFolder/Project_17/S__2507117_0.jpg";
import ProjectFig_17_6 from "./ProjectFolder/Project_17/S__2507120_0.jpg";
import ProjectFig_17_7 from "./ProjectFolder/Project_17/S__2507121_0.jpg";
import ProjectFig_17_8 from "./ProjectFolder/Project_17/S__2507122_0.jpg";
import ProjectFig_17_9 from "./ProjectFolder/Project_17/Towering.jpg";

import ProjectFig_18_1 from "./ProjectFolder/Project_18/1730951233608.jpg";
import ProjectFig_18_2 from "./ProjectFolder/Project_18/1730951763199.jpg";
import ProjectFig_18_3 from "./ProjectFolder/Project_18/GrammarAndParser.png";
import ProjectFig_18_4 from "./ProjectFolder/Project_18/messageImage_1730816947140.jpg";
import ProjectFig_18_5 from "./ProjectFolder/Project_18/messageImage_1730816960561.jpg";
import ProjectFig_18_6 from "./ProjectFolder/Project_18/messageImage_1730816987484.jpg";
import ProjectFig_18_7 from "./ProjectFolder/Project_18/ParseTree.png";
import ProjectFig_18_8 from "./ProjectFolder/Project_18/InterwovenParserAnimation.gif";

import ProjectFig_19_1 from "./ProjectFolder/Project_19/ASS.png";
import ProjectFig_19_2 from "./ProjectFolder/Project_19/Plan.png";
import ProjectFig_19_3 from "./ProjectFolder/Project_19/ProjectPlan.png";
import ProjectFig_19_4 from "./ProjectFolder/Project_19/B_1.png";
import ProjectFig_19_5 from "./ProjectFolder/Project_19/AHP.png";
import ProjectFig_19_6 from "./ProjectFolder/Project_19/Building_System_2.png";
import ProjectFig_19_7 from "./ProjectFolder/Project_19/Material.png";
import ProjectFig_19_8 from "./ProjectFolder/Project_19/TOPSIS1.png";
import ProjectFig_19_9 from "./ProjectFolder/Project_19/M_2.png";

import ProjectFig_20_1 from "./ProjectFolder/Project_20/Integrate.jpg";
import ProjectFig_20_2 from "./ProjectFolder/Project_20/02.png";
import ProjectFig_20_3 from "./ProjectFolder/Project_20/8.png";
import ProjectFig_20_4 from "./ProjectFolder/Project_20/14.png";
import ProjectFig_20_6 from "./ProjectFolder/Project_20/Factory_Graph.png";

import ProjectFig_21_1 from "./ProjectFolder/Project_21/02.png";
import ProjectFig_21_2 from "./ProjectFolder/Project_21/03.png";
import ProjectFig_21_3 from "./ProjectFolder/Project_21/04.png";
import ProjectFig_21_4 from "./ProjectFolder/Project_21/05.png";
import ProjectFig_21_5 from "./ProjectFolder/Project_21/06.png";
import ProjectFig_21_6 from "./ProjectFolder/Project_21/07.png";

import ProjectFig_22_1 from "./ProjectFolder/Project_22/Minecraft.jpg";
import ProjectFig_22_2 from "./ProjectFolder/Project_22/Centrum.png";
import ProjectFig_22_3 from "./ProjectFolder/Project_22/CentrumInside.png";
import ProjectFig_22_4 from "./ProjectFolder/Project_22/Example.png";
import ProjectFig_22_5 from "./ProjectFolder/Project_22/Example02.png";
import ProjectFig_22_6 from "./ProjectFolder/Project_22/Market.png";
import ProjectFig_22_7 from "./ProjectFolder/Project_22/SitePlans.png";
import ProjectFig_22_8 from "./ProjectFolder/Project_22/Site_1.png";
import ProjectFig_22_9 from "./ProjectFolder/Project_22/Site_2.png";
import ProjectFig_22_10 from "./ProjectFolder/Project_22/Site_3.png";
import ProjectFig_22_11 from "./ProjectFolder/Project_22/Site_4.png";
import ProjectFig_22_12 from "./ProjectFolder/Project_22/Site_5.png";
import ProjectFig_22_13 from "./ProjectFolder/Project_22/deal.png";
import ProjectFig_22_14 from "./ProjectFolder/Project_22/2025-02-17_11.47.27.png";
import ProjectFig_22_15 from "./ProjectFolder/Project_22/2025-02-17_11.47.18.png";
import ProjectFig_22_16 from "./ProjectFolder/Project_22/2025-02-17_11.47.34.png";
import ProjectFig_22_17 from "./ProjectFolder/Project_22/2025-02-17_11.47.54.png";
import ProjectFig_22_18 from "./ProjectFolder/Project_22/2025-02-17_11.48.05.png";
import ProjectFig_22_19 from "./ProjectFolder/Project_22/2025-02-17_11.48.13.png";
import ProjectFig_22_20 from "./ProjectFolder/Project_22/2025-02-17_11.48.27.png";


// Enter your Project Details here
export const projectDetails = [
  {
    title: "My Personal Website",
    image: logo,
    description: [
      <p key="1">
        This is my first project to establish a personal website, featuring
        several pages: <br />
        <br />
        <strong>About:</strong> Covers my background, education, and lectures.
        <br />
        <br />
        <strong>Publications:</strong> Showcases published papers, including
        those co-authored with friends. <br />
        <br />
        <strong>Projects:</strong> Lists all ongoing and completed projects.
        <br />
        <br />
        <strong>Monologue:</strong> A space for my personal ideas and concepts.
        <br />
        <br />
        <strong>Resume</strong>(in progress): Will contain my CV. <br />
        <br />
      </p>,
      "The website began with a template from GitHub, thanks to Paven MG, whose link is provided below." +
        " Building on his template, I made various adjustments, particularly focusing on the Publications," +
        " Projects, and the new Monologue page. For Publications, I adapted a similar format from the 'work'" +
        " section to list my papers. However, Projects and Monologue required considerable reconfiguration," +
        " including animations for fading components and expanding content. Throughout this project, I learned" +
        " a lot about using modules like npm and React.js.",
      "Lastly, I've included some images that I plan to incorporate.",
    ],
    links: [
      "https://github.com/pavanmg007/react-developer-portfolio-template",
      "https://tsung-wei-github-io.vercel.app",
      "https://github.com/TzhongWei/TsungWei.github.io",
    ],
    imgs: [profile, ProjectFig_1_2, ProjectFig_1_3, ProjectFig_1_4],
    appendix: [
      <p key="1">
        <strong>Tech</strong> <br /> Javascript, HTML, CSS, npm, Node.js
      </p>,
    ],
  },
  {
    title: "Minecraft Serious Gaming Education",
    image: ProjectFig_22_1,
    description:[
      <p>
        As game-based learning continues to gain momentum, <strong>Minecraft has proven to be a valuable tool for advancing architectural education.</strong> Its versatile sandbox environment allows educators to create interactive and immersive scenarios, helping students to grasp <strong>abstract Mechanical, Electrical, and Plumbing (MEP) concepts </strong>while honing their problem-solving abilities.
      </p>,
      <p>
This study investigates the application of <strong>Minecraft in teaching undergraduate students</strong> about<strong> MEP systems</strong> across various architectural stages, from<strong> pre-design to construction. </strong>To replicate<strong> real-world challenges, </strong>we creatively replaced electricity and piping systems with<strong> Redstone circuits and water channels, </strong>respectively. Students were tasked with<strong> designing and constructing efficient transport systems for farming products,</strong> reflecting real-world water and ventilation networks. Moreover, bidding and resource management were incorporated to mirror the constraints of the Architecture, Engineering, and Construction (AEC) industry. Teams competed for land plots with distinct advantages, purchased materials using in-game currency, and developed farming machines in survival mode. Their <strong>system efficiency was evaluated, with higher profits awarded for more effective designs.</strong> 
      </p>,
      <p>
        The results were highly promising. Students demonstrated<strong> strong strategic planning,</strong> efficiently managed resources, and successfully <strong>executed their projects.</strong> The immersive game environment enhanced engagement, encouraging students to explore online resources to optimise their designs. By assuming multiple roles—<strong>designer, MEP system manager, and builder—students </strong>gained a comprehensive understanding of AEC workflows, refined their problem-solving skills, and adapted creatively to challenges. This study underscores <strong>Minecraft’s significant potential as an innovative educational tool</strong>, capable of simulating complex real-world scenarios and enhancing architectural learning.
      </p>
    ],
    links: ["https://docs.google.com/presentation/d/1uvEp4v1wEXorn-8ZBz6J1AQaXeCvAheAqz9v4wvWB6M/edit?usp=sharing"],
    imgs: [ProjectFig_22_2,ProjectFig_22_3,ProjectFig_22_4,ProjectFig_22_5,ProjectFig_22_6,ProjectFig_22_7,ProjectFig_22_8,ProjectFig_22_9,ProjectFig_22_10,ProjectFig_22_11,ProjectFig_22_12,ProjectFig_22_13,ProjectFig_22_14,ProjectFig_22_15,ProjectFig_22_16,ProjectFig_22_17,ProjectFig_22_18,ProjectFig_22_19,ProjectFig_22_20],
    appendix: [
      <p key="1">
        <strong>Professor YuPin Ma</strong> <br /> National University Kaohsiung
      </p>,
      <p key="2">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="3">
        <strong>Postgraduated student RouSyuan</strong> <br /> National University Kaohsiung
      </p>,
      <p key="2">
      <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
      Science and Technology
    </p>,
    ],
  },
  {
    title: "SL Block Interwoven Structure: Procedural Design and Shape Parser",
    image: ProjectFig_18_2,
    description: [
      <p>
        Sustainable and efficient building solutions in architectural design are
        essential, particularly as{" "}
        <strong>modular and reconfigurable approaches</strong> support
        cradle-to-cradle principles and help reduce waste. Interwoven
        structures, which have roots in traditional craftsmanship, are a proven
        method for enhancing{" "}
        <strong>system integrity and structural stability</strong> through
        topological interlocking between components. <strong>SL Blocks</strong>,
        serving as the fundamental building units with six possible assembly
        configurations, can form various structural components across
        hierarchical levels. This approach aligns with modular design, as
        rule-based generation determines the configuration and relationships
        between components.
      </p>,
      <p>
        This research presents a novel <strong>computational framework</strong>{" "}
        for designing interwoven structures using SL Blocks. Leveraging the six
        transformations and grammatical approaches, this method allows for
        self-supporting, complex assemblies without adhesives or mechanical
        fasteners. In the <strong>rule-based generation</strong> phase, a base
        surface—characterised by height variations and weaving patterns—serves
        as the input. This surface is transformed into interwoven structures,
        divided into voxels and paths to guide the SL Block configuration. To
        streamline the generation of interwoven assemblies, a Rhino
        <strong>Grasshopper-compatible parser</strong> was developed, which
        verifies syntax, tokenises values into a hierarchical model using an LL
        parser, and creates seamless interwoven panels that match the designated
        surface area.
      </p>,
      <p>
        The <strong>assembly strategy phase</strong> involves segmenting
        components into smaller units and establishing an ordered sequence for
        their assembly. The <strong>versatility and scalability</strong> of SL
        Blocks in creating interwoven structures are demonstrated through
        various design hierarchies formed by aggregating SL Blocks. These
        hierarchies and recursive stacking reveal the potential to scale up to
        larger building elements, enabling the construction of substantial
        structures from numerous smaller elements and advancing the efficiency
        and innovation of modular architecture.
      </p>,
    ],
    links: ["https://github.com/TzhongWei/SimpleParserUtil"],
    imgs: [
      ProjectFig_18_1,
      ProjectFig_18_4,
      ProjectFig_18_5,
      ProjectFig_18_6,
      ProjectFig_18_7,
      ProjectFig_18_3,
      ProjectFig_18_8,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Felicia Wagiri</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="4">
        <strong>PhD Ye Yint Aung</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="5">
        <strong>Postgraduated JingYan Chen Neil</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title:
      "Reducing Complexity of Topological Interlocking Assemblies on Surfaces With K-Means",
    image: ProjectFig_21_2,
    description: [
      <p>
        This research addresses the challenges of applying topological
        interlocking (TI) systems to curved surfaces, focusing on the complexity
        of designing custom panels. It aims to reduce fabrication complexity and
        material waste by using K-means clustering to group panels with similar
        geometries, enabling the reuse of formwork while maintaining design
        flexibility.
      </p>,
      <p>
        The research methodology includes three phases: form finding,
        clustering, and block generation. The form-finding phase uses mesh
        optimization to create an efficient curved surface, followed by K-means
        clustering to group panels with similar edge lengths, which reduces the
        need for custom formworks. The block generation phase then creates
        panels that maximize surface coverage with minimal overlaps, ensuring a
        smooth and efficient production process.
      </p>,
      <p>
        The application of K-means clustering significantly reduced the number
        of unique formworks needed, thereby minimizing fabrication complexity
        and waste. The study demonstrates the feasibility of using TI systems
        for curved surfaces while achieving cost-effective and efficient
        production. Future research will focus on developing adjustable
        frameworks and refining the clustering approach to better handle more
        complex geometries.
      </p>,
    ],
    links: undefined,
    imgs: [
      ProjectFig_21_1,
      ProjectFig_21_3,
      ProjectFig_21_4,
      ProjectFig_21_5,
      ProjectFig_21_6,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Felicia Wagiri</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="5">
        <strong>Postgraduated JingYan Chen Neil</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "SL Block Wedding Tower: Hierarchical Assembly",
    image: ProjectFig_16_14,
    description: [
      <p>
        To manage complexity, we aim to organise the system within a
        <strong>hierarchical framework</strong>, aiding in the understanding and
        classification of topological relationships between components.
        Individual elements are systematically arranged to aggregate into
        larger, more complex structures. In this research, the focus is on the{" "}
        <strong>hierarchical assembly of SL blocks</strong>. The framework maps
        out the configuration of block assemblies, demonstrating how assembly
        structures can flexibly integrate multiple SL Block designs. This
        approach not only presents an innovative method for constructing complex
        forms using SL Blocks but also highlights the versatility of the design.
      </p>,
      <p>
        Initially, SL blocks are considered as individual elements, which are
        then combined to form a <strong>conjugated pair</strong>. This pair is
        capable of producing various configurations according to transformation
        code sequences processed by a shape interpreter. The grammar system
        facilitates the representation of multiple levels of elements,
        highlighting the{" "}
        <strong>relationships between superclasses and subclasses</strong>.
        Through literature review and form exploration using the grammar and
        interpreter, a grammar framework was developed to describe architectural
        components. Ultimately, this approach was applied to model{" "}
        <strong>both the Wedding Tower in Darmstadt and a basilica</strong>.
      </p>,
    ],
    links: undefined,
    imgs: [
      ProjectFig_16_1,
      ProjectFig_16_2,
      ProjectFig_16_3,
      ProjectFig_16_4,
      ProjectFig_16_5,
      ProjectFig_16_6,
      ProjectFig_16_7,
      ProjectFig_16_8,
      ProjectFig_16_9,
      ProjectFig_16_10,
      ProjectFig_16_11,
      ProjectFig_16_12,
      ProjectFig_16_13,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Professor Oliver Tessman</strong> <br /> DDU, Technische
        Universitat Darmstadt
      </p>,
      <p key="3">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="4">
        <strong>PhD YuXi Liu</strong> <br /> DDU, Technische Universitat
        Darmstadt
      </p>,
      <p key="5">
        <strong>Postgraduated JingYan Chen Neil</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "SL Block Babel Tower: Towering with Minimal Information",
    image: ProjectFig_17_9,
    description: [
      <p>
        This research focuses on enhancing the efficiency and sustainability of
        constructing <strong>dry-stacking structures</strong> using{" "}
        <strong>SL blocks</strong> by developing a method for{" "}
        <strong>parallel construction</strong>. Drawing inspiration from M.C.
        Escher’s woodcut prints of the Tower of Babel and Filippo Brunelleschi’s
        helical herringbone brickwork in the Duomo di Firenze, this study
        presents tower structures designed for concurrent assembly by
        independent working units. SL blocks, octo-cubes intended for
        dry-stacking, create interlocking structures that require{" "}
        <strong>minimal communication</strong> between units. The assembly
        process involves precise sequencing of components, with temporary
        support added as needed. A key challenge is enabling multiple
        independent units to{" "}
        <strong>build these interlocking structures simultaneously</strong>.
      </p>,
      <p>
        To address this, the study introduces a{" "}
        <strong>computational framework</strong> that uses{" "}
        <strong>grammar</strong> to define interlocking relationships,
        generating <strong>patterns for constructing tower structures</strong>.
        This grammar serves as a{" "}
        <strong>conceptual construction methodology</strong>, outlining
        transformational relationships between structural features and the
        strategic placement of SL blocks. The assembly framework allows each
        working unit to interpret construction progress{" "}
        <strong>independently and respond autonomously</strong>, fostering an
        intuitive construction process. Additionally, an{" "}
        <strong>
          algorithm automates the selection of candidate blocks for parallel
          assembly
        </strong>
        , ensuring collision avoidance and structural stability. Physical models
        of SL block towers were assembled and tested, evaluating various tower
        configurations to determine the feasibility and limitations of the
        proposed parallel construction methods.
      </p>,
      <p>
        Finally, we assembled physical models of SL block towers using
        dry-stacking techniques. We tested various tower configurations to
        evaluate their feasibility and limitations, which allowed us to refine
        strategies for parallel construction that require minimal reliance on
        direct communication.
      </p>,
    ],
    links: [
      "https://www.researchgate.net/publication/383818429_Beyond_Babel_Towering_With_Minimal_Communication",
    ],
    imgs: [
      ProjectFig_17_1,
      ProjectFig_17_2,
      ProjectFig_17_3,
      ProjectFig_17_4,
      ProjectFig_17_6,
      ProjectFig_17_7,
      ProjectFig_17_8,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Professor Oliver Tessman</strong> <br /> DDU, Technische
        Universitat Darmstadt
      </p>,
      <p key="3">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="4">
        <strong>PhD YuXi Liu</strong> <br /> DDU, Technische Universitat
        Darmstadt
      </p>,
      <p key="5">
        <strong>Postgraduated JingYan Chen Neil</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "Interwoven structure Grammar",
    image: ProjectFig_15_9,
    description: [
      <p>
        This research explores the potential of{" "}
        <strong>procedural modeling</strong> to create design and assembly
        sequences for interwoven panel systems. The primary objective is to
        develop a computational framework enabling architects and designers to
        conceptualise and construct interwoven assemblies through{" "}
        <strong>rule-based generation with attribute grammar</strong>. This
        study investigates how procedural modeling can effectively generate
        design and assembly sequences for interwoven panels in architectural
        applications.
      </p>,
      <p>
        The methodology unfolds in two stages. First, the interwoven module was
        developed, with each component kinematically constrained based on its
        geometrical characteristics. Three types of interwoven components were
        created—straight and two types of turnings—sharing a common connection
        system. Second, production rules for assemblies were defined with
        practical applications of attribute grammar. The results indicate that
        attribute grammar is effective in managing rule-based generated
        assemblies, using attributes as semantics to control transformations and
        block placements. This approach offers architects and designers a robust
        computational toolkit for rule-based generation and assembly of
        interwoven panels, advancing complex geometric design within
        architectural practice.
      </p>,
    ],
    links: [
      "https://www.researchgate.net/publication/379961011_RULE-BASED_GENERATION_OF_INTERWOVEN_\nASSEMBLIES_IN_ARCHITECTURAL_DESIGN_A_COMPUTATIONAL_APPROACH_INTEGRATING_ATTRIBUTE_\nGRAMMAR",
      "https://github.com/TzhongWei/SGSFramework",
    ],
    imgs: [
      ProjectFig_15_1,
      ProjectFig_15_2,
      ProjectFig_15_3,
      ProjectFig_15_4,
      ProjectFig_15_5,
      ProjectFig_15_6,
      ProjectFig_15_7,
      ProjectFig_15_8,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Ye Yint Aung</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="5">
        <strong>PhD Felicia Wagiri</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
    ],
  },
  {
    title: "PolyVox",
    image: ProjectFig_10_1,
    description: [
      <p>
        One of the concepts of Truchet Tiling involves using regular tiling to
        create various patterns through rotations. The key factor in this effect
        is the shared connection positions of the tiles, which creates the
        appearance of continuous links. Traditionally, this tiling technique can
        only be used for regular triangles, squares, and hexagons, as they are
        the only shapes that can tessellate the plane infinitely.
      </p>,
      <p>
        PolyVox, instead, was an artwork based on the aforementioned concept,
        extending it by applying cubes to voxel art, which can be arranged in
        three-dimensional space. Joints were created at the centre of each face.
        Additionally, spheres of different sizes and connecting pipes were used
        to create intricate patterns.
      </p>,
    ],
    links: [
      "https://gallery.bridgesmathart.org/exhibitions/2023-bridges-conference/kevin-harsono-shen-guan-shih-felicia-wagiri-tsungwei-cheng",
    ],
    imgs: [
      ProjectFig_10_2,
      ProjectFig_10_3,
      ProjectFig_10_4,
      ProjectFig_10_5,
      ProjectFig_10_6,
      ProjectFig_10_7,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Felicia Wagiri</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
    ],
  },
  {
    title: "Small Architectural Business Model Game with Tico Blocks",
    image: ProjectFig_11_2,
    description: [
      <p>
        This game was developed as part of{" "}
        <strong>Professor ShenGuan Shih’s BIM classes</strong>
        to teach students about the business model in{" "}
        <strong>
          the Architecture, Engineering, and Construction (AEC) industry
        </strong>
        . To further test its effectiveness, this module was also applied in one
        of my lectures at the National University of Kaohsiung. The primary goal
        of this game-based business model was to help students understand how
        gathering information early in the design process leads to more informed
        design decisions.
      </p>,
      <p>
        Professor Shih often likens architectural decision-making to a path
        connecting starting points with target goals, such as budget,
        environmental control, and overall building performance. Designers often
        aim for a direct path to achieve these goals, yet following a
        straightforward route can sometimes be too tedious. As a result,
        designers create more complex paths to explore different design options.
        However, this approach has its risks; if designers make decisions
        without evaluating each step thoroughly, they may encounter costly
        issues, needing additional resources, time, and budget to adjust and
        correct the design trajectory.
      </p>,
      <p>
        This game focuses on teaching students to identify and analyse essential
        information early in the design phase. For instance, students assessed
        heat insulation and building costs initially, prompting them to consider
        adjustments early on. They also plannned material usage, which impacted
        insulation and cost, and participate in simplified site bidding
        exercises to simulate real-world conditions. These choices affected the
        income generated from their designs, with closer alignment to optimal
        choices yielding better results. Various factors were integrated to
        challenge students’ decision-making.
      </p>,
      <p>
        Ultimately, this game-based exercise showed that students not only
        grasped the AEC business model but also produced better design outputs
        from the initial stages.
      </p>,
    ],
    links: [
      "https://github.com/TzhongWei/BIM-Game.git",
      "https://www.researchgate.net/publication/376721500_Exploration_of_Building_Information_Modeling_and_Integrated_Project_Cloud_Service_in_early_architectural_design_stages",
    ],
    imgs: [ProjectFig_11_1, ProjectFig_11_3, ProjectFig_11_4, ProjectFig_11_5],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="1">
        <strong>Associate Professor YuPin Ma</strong> <br /> National University
        of Kaohsiung
      </p>,
      <p key="2">
        <strong>PhD GuiLin Zhuang</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Felicia Wagiri</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="4">
        <strong>Postgraduated TsungHuan Li Bus</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="5">
        <strong>Postgraduated TingWan Huang</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "Principal Curvature algorithm for concrete shells molds",
    image: ProjectFig_12_1,
    description: [
      <p>
        This project was part of the fabric-forming shells research led by my
        PhD labmate, <strong>Felicia Wagiri</strong>. My role was to help
        develop a program to determine <strong>principal curvatures</strong> on
        a surface, which would then subdivide the surface into grids to
        facilitate shell structure formation.
      </p>,
      <p>
        Traditionally, principal curvature algorithms approximate orientation by
        calculating the largest and smallest curvature directions from the
        previous point. If the distance between points is sufficient, a curve
        can be derived. However, our lab explored an alternative algorithm.
        Since points on a principal curvature curve share the same normal
        vector, we refined the approximation by comparing a set of options at
        each step, rather than directly relying on the preceding step’s
        direction. Users could adjust sample numbers and ranges, selecting the
        smallest normal vector difference through a dot product with the
        original point.This new approach produced results that more accurately
        followed the principal curvature curve.
      </p>,
    ],
    links: [
      "https://github.com/TzhongWei/Principal_Curvature",
      "https://www.researchgate.net/publication/384291461_Bending-active_molds_for_pre-fabricated_concrete_shells",
    ],
    imgs: [ProjectFig_12_2],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Assistant Professor YuChuan Kao</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Felicia Wagiri</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>Postgraduated student MuKuan Lu</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "MonoTiles: Hat Tiles design",
    image: ProjectFig_13_6,
    description: [
      <p>
        The <strong>MonoTile: Hat</strong> is a unique tile shape within the
        realm of geometric tiling, introduced as part of a groundbreaking
        discovery in mathematical tiling theory. Known as an
        <strong> "aperiodic monotile"</strong> or "einstein tile," the Hat is a
        single tile shape that can cover a plane without creating a repeating
        pattern. This property makes it a notable discovery because, unlike
        traditional tiling patterns, the Hat's arrangement is
        <strong>non-repeating and aperiodic</strong>, meaning that while it
        fills the plane, it never repeats the same configuration across the
        entire surface.
      </p>,
      <p>
        Developed in recent years by a team of mathematicians, including
        <strong>
          David Smith, Joseph Samuel Myers, Craig S. Kaplan, and Chaim
          Goodman-Strauss,
        </strong>
        the Hat tile has captivated both researchers and enthusiasts. It
        challenges longstanding assumptions about tiling, offering insights into
        both <strong>mathematics and materials science</strong> due to its
        implications for quasicrystals and non-repeating patterns. The Hat
        tile's shape, resembling a hat, can be arranged in numerous
        configurations while maintaining a distinct lack of periodicity, making
        it a fascinating subject in{" "}
        <strong>mathematics, design, and architecture.</strong>
      </p>,
      <p>
        This unique property of the Hat tile has implications for various
        fields, especially in <strong>design applications</strong> where
        non-repetitive patterns are desirable, as well as in material sciences
        where understanding aperiodic tiling can inform the creation of novel
        materials and structures.
      </p>,
      <p>
        In response, our lab developed a Grasshopper plugin to streamline design
        with the Hat tile. This plugin allows designers to create patterns and
        geometries within the Hat tile’s framework, with options to set specific
        arrangement types—<strong>H, T, P, and F</strong>—which can be tailored
        to user requirements.
      </p>,
      <p>
        Using the plugin, <strong>Fatmat</strong> designed a variety of
        patterns, including
        <strong>curved and Islamic-inspired styles.</strong> She also applied it
        to configure a global map, where the tiles represented{" "}
        <strong>mountains and valleys</strong> arranged according to altitude.
        Additionally, <strong>Kevin Harsono</strong> used the plugin to design{" "}
        <strong>curtain walls</strong>, developing a structural framework to
        support the unique tile arrangements.
      </p>,
    ],
    links: [
      "https://github.com/TzhongWei/EinsteinHat_GH",
      "https://github.com/isohedral/hatviz",
      "https://www.researchgate.net/publication/383039499_Hat_Monotiles_Driving_Innovation_in_Aperiodic_\nPattern_Generation_and_Application",
    ],
    imgs: [
      ProjectFig_13_1,
      ProjectFig_13_2,
      ProjectFig_13_3,
      ProjectFig_13_4,
      ProjectFig_13_5,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Postgraduated student Fatma Kayatekin</strong> <br />{" "}
        Postgraduated student <br /> National Taiwan University of Science and
        Technology
      </p>,
      <p key="3">
        <strong>PhD Kevin Harsono</strong> <br /> Postgraduated student <br />{" "}
        National Taiwan University of Science and Technology
      </p>,
      <p key="4">
        <strong>PhD Felicia Wagiri</strong> <br /> Postgraduated student <br />{" "}
        National Taiwan University of Science and Technology
      </p>,
    ],
  },
  {
    title: "Information Scape : Agent-Based Model",
    image: ProjectFig_14_1,
    description: [
      <p>
        Access to information greatly influences individual decision-making. The
        concept of <strong>information scape</strong>, introduced by our lab’s
        PhD student <strong>Ye Yint Aung</strong>, examines how people behave in
        response to different information scenarios. This research focuses on
        the visual domain and how individuals gather information in a space to
        decide on destinations, using{" "}
        <strong>Agent-Based Modeling (ABM)</strong> to simulate behaviors within
        complex systems.
      </p>,
      <p>
        Imagine navigating to a location within a space: typically, we look for
        the closest path to our destination. However, the path is often
        indirect, potentially obstructed by walls or other dynamic elements.
        Without an internal map, we rely on signs and cues along the way, all
        within the limitations of our visual range. Additionally, we may have
        other tasks to accomplish before reaching our main destination. Given
        these variables, our daily navigation is influenced by multiple factors
        and pieces of information that lead to different outcomes. Observing and
        categorizing each person’s actions would be overwhelming due to the
        complexity, so we simplify these behaviors, applying theoretical
        frameworks to study how agents would likely act in such settings.
      </p>,
      <p>
        For example, we often manage tasks using a{" "}
        <strong>stacking approach</strong>: when a new task appears, it’s added
        to the stack (pushed), and we only move to another task once the current
        one is completed (popped). Our goal-oriented behaviors are also
        well-represented by a <strong>discrete probability model</strong>. To
        simulate individual decision-making across multiple tasks, we employ
        Markov Chains. A key aspect of this study is the
        <strong> propagation of information</strong> to various targets within
        the space, requiring agents to gather information dynamically as they
        move. To facilitate this, we apply the{" "}
        <strong>Dijkstra algorithm</strong> to calculate and distribute target
        distances for each individual agent.
      </p>,
    ],
    links: [
      "https://github.com/TzhongWei/ABxMAddon.git",
      "https://www.food4rhino.com/en/app/abxmcore",
      "https://www.researchgate.net/publication/379977834_ON_THE_INFORMATION_SCAPE_OF_SPACES",
    ],
    imgs: [ProjectFig_14_2, ProjectFig_14_3, ProjectFig_14_4, ProjectFig_14_5],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>PhD Ye Yint Aung</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
      <p key="3">
        <strong>PhD Kevin Harsono</strong> <br /> National Taiwan University of
        Science and Technology
      </p>,
    ],
  },
  {
    title: "DAKA",
    image: ProjectFig_8_1,
    description: [
      <p>
        This was an internship project with{" "}
        <strong>Global Reengineering Company Limited</strong> , where we
        assisted in optimizing the{" "}
        <strong>Ultra High Performance Concrete (UHPC)</strong>
        curtain panel design for DAKA, a development on Taiwan's east coast. The
        project was developed by <strong>Taiwan Cement Corporation</strong>, one
        of Taiwan's largest cement companies, with the building designed by
        <strong> Kohn Pedersen Fox Associates (KPF)</strong>, an international
        architectural firm based in the U.S.
      </p>,
      <p>
        Due to the curved surface of the building and stair arrangements, the
        project required<strong> over 200 unique panel types</strong>, which
        significantly increased construction costs and resulted in substantial
        mold waste. Our objective was to optimise the panel shapes and reduce
        the number of unique UHPC components to enhance mold reusability,
        thereby minimizing waste and reducing costs.
      </p>,
      <p>
        We analysed the KPF model, designed as a column trimmed by the building
        and stairs. The surface was divided into three nearly equal sections
        from top to bottom and further split into 142 rows. By vectorizing the
        shapes based on properties like angle and area, we grouped them using
        <strong>K-means clustering</strong> within a tolerance of two
        centimeters, as specified by KPF. The panels were replaced with central
        vectors, and each component was reformed according to its design
        concept. To reduce panel weight, we maintained a thickness of three
        centimeters and added ribs to increase strength.
      </p>,
      <p>
        In the mold design phase, we used <strong>Euler Angles</strong> to
        determine the optimal casting orientation, ensuring a clean surface
        finish. We aligned the panels consistently for casting by orienting them
        onto a shared base mold using the calculated angles to create outer
        molds.
      </p>,
      <p>
        The project spanned two years, involving extensive communication among
        the developer, architects, and construction teams, with information
        flowing between the U.S. and Taiwan. Various algorithms were used to
        analyse panel shapes, structural similarities, and configurations. The
        experience was highly valuable, providing meaningful insights into
        practical design optimisation.
      </p>,
    ],
    links: ["https://www.grca.com.tw/album/4/1"],
    imgs: [
      ProjectFig_8_2,
      ProjectFig_8_6,
      ProjectFig_8_3,
      ProjectFig_8_4,
      ProjectFig_8_5,
    ],
    appendix: [
      <p key="2">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Global Reengineering Co. Lt.</strong>
      </p>,
      <p key="2">
        <strong>Postgraduated student Kevin Harsono</strong> <br /> National
        Taiwan University of Science and Technology
      </p>,
    ],
  },
  {
    title: "UHPC Chinese Zodiac panels",
    image: ProjectFig_9_4,
    description: [
      <p>
        Since <strong>Ultra High Performance Concrete (UHPC)</strong> offers
        superior fluidity compared to other concrete types, it allows for
        detailed casting patterns. Additionally, its exceptional durability and
        strength increase the reusability of components. With these qualities in
        mind, Professor ShenGuan Shih aimed to promote UHPC within Taiwan's AEC
        industry, where concrete remains the primary construction material.
      </p>,
      <p>
        One effective way to showcase UHPC’s benefits is through creating
        <strong> handcrafted or small items</strong> that people can easily
        display on their desks. This led to the concept for the project: using a
        regular triangle as the foundational shape, allowing it to be assembled
        into various platonic forms and solids. We designed the 12 animals of
        the Chinese Zodiac onto these pieces, encouraging people to collect the
        full set. Each panel connects with the others using magnetic joints,
        forming a cohesive display when fully assembled.
      </p>,
      <p>
        In this project, YuChun and I were responsible for fabricating the
        panels. We used an SLA 3D printer to create the female mold and then
        made the final mold out of silicone. Afterward, we sent the molds to
        Global Reengineering Co. Ltd. for casting in UHPC. Once the pieces were
        cast, we attached magnets to the joints, completing the product.
      </p>,
    ],
    links: undefined,
    imgs: [
      ProjectFig_9_1,
      ProjectFig_9_2,
      ProjectFig_9_3,
      ProjectFig_9_5,
      ProjectFig_9_6,
      ProjectFig_9_7,
      ProjectFig_9_8,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Global Reengineering Co. Lt.</strong>
      </p>,
      <p key="3">
        <strong>Postgraduated student YuChun Chen</strong> <br /> National
        Taiwan University of Science and Technology
      </p>,
      <p key="4">
        <strong>Postgraduated student MuKuan Lu</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "Dual Images Wall",
    image: ProjectFig_5_3,
    description: [
      <p>
        This project was initiated by <strong> Iuan Kai Fang</strong>, a PhD
        student in our lab and design director at <strong>KEA CREATIVE.</strong>{" "}
        The objective was to design a <strong>feature wall</strong> for the
        College of Electrical Engineering and Computer Science at National Tsing
        Hua University. The college wanted a tribute wall to honor their former
        president, displaying both his portrait and his well-known theory.
        Inspired by <strong>water jet cutting techniques</strong> on Ultra High
        Performance Concrete (UHPC) and light grating, we created a design with
        engravings and triangular protrusions to reveal two distinct images from
        different viewing angles.
      </p>,
      <p>
        In the initial design phase, we used Grasshopper to analyse each pixel’s
        color code, translating this data into depth variations for the
        engraving slots on the wall's surface. We experimented with different
        engraving shapes, like trapezoids and triangles, to determine the most
        effective profiles. The <strong>angle of the triangular faces </strong>
        on the protrusions was carefully analysed to optimise the viewing
        perspective, enhancing the visibility of each image based on inclination
        ratios. In the final design phase, we fine-tuned parameters and rotated
        the engraving patterns to ensure the images would appear clearly from
        specific angles.
      </p>,
      <p>
        With support from <strong>Global Reengineering Co. Ltd.</strong>, we
        developed a mold and successfully cast the concrete wall. The
        engravings, ranging from one to five millimeters in width, presented
        challenges in retaining the fine details after the concrete solidified.
        We used a wooden female mold to capture the image patterns, assembling
        the triangular faces to create an integrated mold that displayed the
        final images as intended.
      </p>,
    ],
    links: [
      "https://www.youtube.com/watch?v=AlT5K5mD_MM&t=311s",
      "https://www.youtube.com/watch?v=257ROuq5XYs",
    ],
    imgs: [
      ProjectFig_5_1,
      ProjectFig_5_2,
      ProjectFig_5_5,
      ProjectFig_5_6,
      ProjectFig_5_8,
    ],
    appendix: [
      <p key="1">
        <strong>Design Director and PhD Iuan Kai Fang</strong> <br /> KEA
        CREATIVE
        <br /> National Taiwan University of Science and Technology
      </p>,
      <p key="2">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Global Reengineering Co. Lt.</strong>
      </p>,
      <p key="2">
        <strong>Postgraduated student YuChun Chen</strong> <br /> National
        Taiwan University of Science and Technology
      </p>,
    ],
  },
  {
    title: "LCA of Building with MultiObjective Optimisation",
    image: ProjectFig_19_1,
    description: [
      <p>
        This project presents a life-cycle assessment (LCA) and maintenance
        planning for integrated systems in a school building, focusing on
        materials like wooden ceilings, facades, and pavements. The study
        highlights the building sector's environmental impact, accounting for
        around 40% of CO2 emissions and 35% of global energy consumption. To
        mitigate these effects, the report evaluates various integrated building
        materials—concrete blocks, cross-laminated timber (CLT), and
        prefabricated reinforced concrete (PRC)—using LCA and multi-objective
        optimization techniques.
      </p>,
      <p>
        The maintenance strategy explores both preventive and corrective
        maintenance, with a goal of enhancing durability, efficiency, and
        sustainability. Design option 4, featuring PRC, CLT, and pavement, was
        identified as the optimal solution, balancing environmental impact,
        cost, and longevity. The multi-objective optimization utilized Genetic
        Algorithms to determine the most efficient intervention strategies. The
        report concludes that integrating diverse systems with a well-planned
        maintenance approach can significantly enhance building performance
        while reducing environmental impacts.
      </p>,
    ],
    links: undefined,
    imgs: [
      ProjectFig_19_2,
      ProjectFig_19_3,
      ProjectFig_19_4,
      ProjectFig_19_5,
      ProjectFig_19_6,
      ProjectFig_19_7,
      ProjectFig_19_8,
      ProjectFig_19_9,
    ],
    appendix: [
      <p key="1">
        <strong>Professor Timo Hartmann</strong> <br /> Technische Universitat
        Berlin
      </p>,
      <p key="2">
        <strong>PhD Mohamed Abdelfattah</strong> <br /> Technische Universitat
        Berlin
      </p>,
      <p key="3">
        <strong>Postgraduated student Eren Cavusoglu</strong> <br /> Technische
        Universitat Berlin
      </p>,
      <p key="3">
        <strong>Postgraduated student Marlon Theis</strong> <br /> Technische
        Universitat Berlin
      </p>,
      <p key="3">
        <strong>Postgraduated student Mustafa Atici</strong> <br /> Technische
        Universitat Berlin
      </p>,
      <p key="3">
        <strong>
          Postgraduated student Mounami Beeragondara Hanumanthappa
        </strong>{" "}
        <br /> Technische Universitat Berlin
      </p>,
      <p>
        Tech <br />R language
      </p>,
    ],
  },
  {
    title: "Integrating Modeling system",
    image: ProjectFig_20_1,
    description: [
      <p>
        This project builds on the aim of the initial assignment by exploring
        the integration of civil engineering models in a more complex and
        contextualized setting. Specifically, the focus is on combining
        previously developed ontological and parametric models within an
        industrial zone that includes a steel bridge, concrete road, warehouse,
        precast concrete factory, and a garage.
      </p>,
      <p>
        The goal of this assignment is to apply different ontologies and
        parametric models to create a cohesive representation of an industrial
        area, enabling a better understanding of construction processes,
        material interactions, and design options. This integrated approach
        helps showcase the connections between various systems in an urban
        environment, supporting designers, scholars, and town planners in
        visualizing a complete industrial setup.
      </p>,
    ],
    links: undefined,
    imgs: [ProjectFig_20_2, ProjectFig_20_3, ProjectFig_20_4, ProjectFig_20_6],
    appendix: [
      <p key="2">
        <strong>Professor Timo Hartmann</strong> <br /> Technische Universitat
        Berlin
      </p>,
      <p>
        <strong>Postgraduated student Muhammed Imran</strong> <br /> Technische
        Universitat Berlin
      </p>,
      <p>
        <strong>Postgraduated student Rajat Saini</strong> <br /> Technische
        Universitat Berlin
      </p>,
      <p>
        <strong>Postgraduated student Sangaj Haladkar</strong> <br /> Technische
        Universitat Berlin
      </p>,
      <p>
        <strong>Postgraduated student Jahnavi Trivedi</strong> <br /> Technische
        Universitat Berlin
      </p>,

      <p>
        <strong>Tech</strong> <br />
        Ontology
        <br />
        Dynamo
      </p>,
    ],
  },
  {
    title: "CUBE CSE",
    image: ProjectFig_6_1,
    description: [
      <p>
        This project was initiated by <string>Iuan Kai Fang </string>, a PhD
        student in our lab and design director at <string>KEA CREATIVE.</string>{" "}
        The concept involved creating a cube matrix that would illustrate the
        letters S, C, and E, representing the College of Electrical Engineering
        and Computer Science at National Tsing Hua University. We aimed to
        feature these three letters from different orientations along the X, Y,
        and Z axes.
      </p>,
      <p>
        To achieve this, we first modelled the letters S, E, and C on three
        separate planes, performing a solid union to identify the shared
        sections among the letters. Next, we set up a grid-based cubic model
        that encompassed both the solid and grid, increasing the grid density
        around the intersecting parts to emphasise the letters from each
        perspective.
      </p>,
    ],
    links: [
      "https://www.youtube.com/watch?v=AlT5K5mD_MM&t=311s",
      "https://www.youtube.com/watch?v=257ROuq5XYs",
    ],
    imgs: [
      ProjectFig_6_2,
      ProjectFig_6_3,
      ProjectFig_6_4,
      ProjectFig_6_5,
      ProjectFig_6_6,
    ],
    appendix: [
      <p key="1">
        <strong>Design Director and PhD Iuan Kai Fang</strong> <br /> KEA
        CREATIVE
        <br /> National Taiwan University of Science and Technology
      </p>,
      <p key="2">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
    ],
  },
  {
    title: "Topological Interlocking Block Curtain Design",
    image: ProjectFig_3_1,
    description: [
      <p>
        This was an <strong>industrial collaboration project </strong>with
        ZhenXi Construction Company in Taiwan. Our task was to design curtain
        walls on the balcony of the company’s rooftop.{" "}
        <strong>UHPC (Ultra-High Performance Concrete)</strong> was chosen for
        its excellent flexibility, durability, and strength to create a hollow
        effect for the panels. The developer desired a Japanese
        landscape-inspired design, with an emphasis on a simple, grid-based
        pattern. Additionally, our professor aimed to integrate modular
        component design and reusable masonry concepts. A full cast grid wall
        was not used; instead, we implemented the{" "}
        <strong>Topological Interlocking (TI) system</strong>.
      </p>,
      <p>
        The Topological Interlocking Assembly (TIA) is a dry-stacking masonry
        structure where each element is kinematically constrained by its
        neighboring components up to the system's edge. This makes{" "}
        <strong>border strength </strong>critical for stability. TIA also allows
        for self-alignment of individual elements, minimising errors without
        adhesives. Even with cracks or missing pieces, up to a quarter of the
        elements, the system remains functional and prevents collapse, making it
        ideal for this project.
      </p>,
      <p>
        We developed several prototypes. To enhance tensile strength between
        components and the border, we applied post-tensioning techniques,
        inspired by “The Flat Vault” method. We also added interlocking keys at
        the borders to reduce shear forces and experimented with Truchet tiling
        for rotational patterns. Additionally, we proposed block shapes like the
        '井' design. We printed them out with 3D printers to Test the feasbility
        of the designed components, and even cast it with full scale model.
        Overall, this was my first project during my master’s program and an
        exciting opportunity to realise design concepts through a dry-stacking
        structural system and UHPC.
      </p>,
    ],
    links: ["https://www.platformarchitecture.it/en/the-flat-vault/"],
    imgs: [
      ProjectFig_3_2,
      ProjectFig_3_3,
      ProjectFig_3_4,
      ProjectFig_3_5,
      ProjectFig_3_6,
      ProjectFig_3_7,
      ProjectFig_3_8,
      ProjectFig_3_9,
      ProjectFig_3_10,
      ProjectFig_3_11,
      ProjectFig_3_12,
      ProjectFig_3_13,
      ProjectFig_3_14,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Postgraduated student Kevin Harsono</strong> <br /> National
        Taiwan University of Science and Technology
      </p>,
      <p key="3">
        <strong>Postgraduated student TsungHuan Li Bus</strong> <br /> National
        Taiwan University of Science and Technology
      </p>,
      <p key="3">
        <strong>Postgraduated student ZhengTing Huang Tim</strong> <br />{" "}
        National Taiwan University of Science and Technology
      </p>,
      <p key="4">
        <strong>Global Reengineering Co. Lt.</strong>
      </p>,
      <p key="4">
        <strong>鎮囍建設</strong>
      </p>,
      <p key="4">
        <strong>蘇博特新材料</strong>
      </p>,
      <p key="4">
        <strong>Wei&Wei InAternational Architectsand Planners</strong>
      </p>,
    ],
  },
  {
    title: "Tico_Block",
    image: ProjectFig_2_1,
    description: [
      <p>
        <strong>Reusable component design</strong> continues to be a critical
        research area in both <strong>the AEC industry</strong> and
        architectural education. Tico blocks, a type of small building block
        system developed in Taiwan, are used as an educational tool to help
        students practice component-based design. However, due to the limited
        types of Tico components, my labmate, Sprout, and I were asked by Prof.
        Shih to assist in developing a small Grasshopper 'GH' program to
        generate Tico joints on custom blocks. By using this shared interface
        between components, customised Tico blocks could be created with GH
        modeling and then 3D printed to complete student projects.
      </p>,
      <p>
        The main challenge of this project was aligning shared interfaces on
        target planar surfaces and adjusting joint positions, allowing students
        to attach Tico joints in various orientations. This flexibility enabled
        the
        <strong>blocks to be stacked in multiple directions</strong>.
        Additionally, after the studio session, these Tico-based components
        could be easily reassembled, as they utilise dry joints and a shared
        interface system, supporting the concept of design for reuse within a
        circular economy. This project provided an engaging way to explore
        sustainable design principles through reusable components.
      </p>,
    ],
    links: undefined,
    imgs: [ProjectFig_2_2, ProjectFig_2_3, ProjectFig_2_4, ProjectFig_2_5],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Postgraduated student MuKuan Lu Sprout</strong> <br />{" "}
        Postgraduated student <br /> National Taiwan University of Science and
        Technology
      </p>,
    ],
  },
  {
    title: "Wavy Module Design From Osteomorphic Interlocking Block",
    image: ProjectFig_4_4,
    description: [
      <p>
        Inspired by modular design principles and test concrete modules from our
        university's Department of Civil and Construction Engineering, this
        project seeks to develop a{" "}
        <strong>
          modular casting system for Osteomorphic Interlocking (OI) Blocks using
          Ultra High Performance Concrete (UHPC).
        </strong>{" "}
        We employed 3D printing (FDM) and CNC machining to fabricate the molds
        for this exercise.
      </p>,
      <p>
        To optimise the casting process for the OI blocks, we planned to cast
        them in batches. Reusability of the mold was also a primary objective,
        leading us to select a decomposable mold. However, because the OI block
        belongs to the topological interlocking block category, conventional
        removal methods were unsuitable. The challenge was in safely removing
        the mold along the interlocking faces. To address this, we designed a
        mold that disassembles from its interlocking surfaces. We further
        incorporated slots to secure the mold and minimise concrete leakage
        during casting. Additionally, we embedded 3D-printed pipes within the
        mold to create channels, allowing for easy post-casting assembly of the
        components.
      </p>,
    ],
    imgs: [
      ProjectFig_4_1,
      ProjectFig_4_2,
      ProjectFig_4_3,
      ProjectFig_4_5,
      ProjectFig_4_6,
      ProjectFig_4_7,
      ProjectFig_4_8,
      ProjectFig_4_9,
      ProjectFig_4_10,
    ],
    appendix: [
      <p key="1">
        <strong>Professor ShenGuan Shih</strong> <br /> National Taiwan
        University of Science and Technology
      </p>,
      <p key="2">
        <strong>Assistant Professor YuCyuan Gao</strong> <br /> National Taiwan
        University of Science and Technology <br /> The department of Civil and
        Construction Engineering
      </p>,
      <p key="2">
        <strong>Postgraduated student Kevin Harsono</strong> <br /> National
        Taiwan University of Science and Technology
      </p>,
    ],
  },
  {
    title: "Rotary exhibition",
    image: ProjectFig_7_5,
    description: [
      <p>
        This design project was initiated by <strong>Iuan Kai Fang</strong>, a
        PhD student in our lab and design director at{" "}
        <strong>KEA CREATIVE</strong>. Due to the pandemic, most exhibitions had
        to transition online, and he approached me to design a virtual
        exhibition for Rotary, a global organisation.
      </p>,
      <p>
        The design concept featured{" "}
        <strong>layers of ellipses and gears </strong> forming the top of the
        exhibition space. Between these layers, we incorporated a space frame
        and lighting to enhance the structure’s depth. The final model was
        prepared for online display, utilising VR technology. We worked through
        various discussions to refine the visual effects and details of the
        model to ensure an immersive virtual experience.
      </p>,
    ],
    imgs: [
      ProjectFig_7_1,
      ProjectFig_7_2,
      ProjectFig_7_3,
      ProjectFig_7_4,
      ProjectFig_7_6,
      ProjectFig_7_7,
    ],
    appendix: [
      <p key="1">
        <strong>Design Director and PhD Iuan Kai Fang</strong> <br /> KEA
        CREATIVE
        <br /> National Taiwan University of Science and Technology
      </p>,
    ],
  },
];
